<template>
  <v-container class="home-page">
    <div v-show="!showVideo">
      <div class="bg-fixed-100" :style="{ backgroundImage: 'url(' + homepageBg + ')' }"></div>
      <div class="bg-fixed-100 train"></div>
      <div v-if="$root.loggedIn"
        :class="{'right': currentOver === 'right'}"
        class="bg-fixed-100 foreground"
        :style="{ backgroundImage: 'url(' + homepageFg + ')' }"></div>

      <img :src="logoAnimation" class="main-logo big">

      <div v-if="$root.loggedIn">
        <router-link :to="{ name: 'Women'}" @mouseover.native="currentOver = 'left'">
          <h4 class="ticket female font-kristi">La terre <br>des Femmes</h4>
        </router-link>
        <router-link :to="{ name: 'Men'}" @mouseover.native="currentOver = 'right'">
          <h4 class="ticket male font-kristi">La terre <br>des Hommes</h4>
        </router-link>
      </div>
      <div v-else class="home-comingsoon ">
        <h5 class="font-jost bold">PASSWORD:</h5>
        <input type="password" v-model="password">
      </div>

    </div>

    <transition name="fade">
      <div class="video-container" v-show="showVideo && videoLoaded">

        <vue-plyr
          @ended="onVideoEnded"
          @ready="onVideoReady"
          class="player absolute-center"
          :style="{width: videoSize.w + 'px', height: videoSize.h + 'px'}"
          ref="plyr">
          <video :src="introVideo" playsinline crossorigin autoplay muted></video>
        </vue-plyr>
        <div class="black-box"></div>
        <router-link :to="{ name: 'Home'}" @click.native="$emit('headerClick')">
          <img :src="$root.logo" class="main-logo big relative">
        </router-link>
        <Header class="home-header" @headerClick="onVideoEnded"></Header>
      </div>
    </transition>
  </v-container>
</template>

<script>
import Header from '../organisms/Header.vue'

import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'
import homepageBg from '@/assets/img/homepage-bg-selection.jpg'
import homepageFg from '@/assets/img/homepage-selection-fg.png'
import logoAnimation from '@/assets/img/logo-animation.gif'
import VuePlyr from 'vue-plyr'
import Vue from 'vue'
import introVideo from '@/assets/video/intro-screen.mp4'
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false },
    hideControls: true,
    autoplay: true,
    muted: true,
    playsinline: true
  },
  emit: ['ready', 'ended']
})

export default {
  name: 'Home',

  mixins: [Viewport],

  components: {
    Header
  },

  data () {
    return {
      currentOver: 'left',
      logoAnimation,
      password: '',
      homepageBg,
      homepageFg,
      showVideo: true,
      videoLoaded: false,
      introVideo
    }
  },
  mounted () {
    // console.log(this.$root.config)
    if (this.$root.introSeen) {
      this.showVideo = false
    } else {
      if (this.$refs.plyr) {
        this.$refs.plyr.player.on('ended', this.onVideoEnded)
        this.$refs.plyr.player.on('ready', this.onVideoReady)
      }
    }
    this.$root.introSeen = true

    if (window.location.hostname.indexOf('localhost') > -1) {
      this.$root.loggedIn = true
    }
  },

  methods: {
    onVideoEnded (skip) {
      this.showVideo = false
      console.log('onVideoEnd')
    },
    onVideoReady () {
      console.log('onVideoReady')
      if (this.$refs.plyr) {
        this.videoLoaded = true
        this.player = this.$refs.plyr.player
        this.player.play()
      }
    },
    openCollection (cat) {
      this.$router.push({
        name: 'Collection',
        params: {
          collection: cat.toLowerCase()
        }
      })
    }
  },

  watch: {
    password: function (value) {
      if (value === 'choochoo') {
        this.$root.loggedIn = true
      }
    }
  },

  computed: {
    videoSize () {
      const ratio = Math.max(this.viewPort.width / 1920, this.viewPort.height / 1080)
      return { w: 1920 * ratio, h: 1080 * ratio }
    }
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.foreground {
  &.right {
    transform: scaleX(-1);
  }
}

.ticket {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 50px;
  background-size: 100%;
  cursor: pointer;
  transition: transform 0.5s;

  &:hover {
    transform: translate(-50%, -50%) scale(1.2);
  }

  &.male {
    color: $c-yellow;
    left: 75%;
    background-image: url('../assets/img/ticket-male.png');
    filter: drop-shadow(2px 2px 0 $c-red);
    text-shadow:
      1px 1px 0 $c-red,
      -1px 1px 0 $c-red,
      -1px -1px 0 $c-red,
      1px -1px 0 $c-red;
  }

  &.female {
    color: $c-red;
    left: 25%;
    background-image: url('../assets/img/ticket-female.png');
    filter: drop-shadow(2px 2px 0 $c-yellow);
    text-shadow:
      1px 1px 0 $c-yellow,
      -1px 1px 0 $c-yellow,
      -1px -1px 0 $c-yellow,
      1px -1px 0 $c-yellow;
  }
}

.train {
  background-image: url('../assets/img/homepage-train-selection.png');
  background-repeat: repeat-x;
  background-size: cover;
  animation: slide 40s linear infinite;
}

@keyframes slide {
  from { background-position: 0 0; }
  to { background-position: -1920px 0; }
}

.video-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
}

::v-deep .plyr__control,
::v-deep .plyr__controls {
  display: none;
}

.home-header {
  position: absolute;
  top: 30%;
  left: 0;
  display: inline-block;
  transform: translateX(-50%);
  z-index: 2;
}

.home-comingsoon {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
  color: $c-red;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;

  input {
    border: 1px solid #000;
  }
}

.product {
  position: absolute;
  padding: 10px;
  width: fit-content;
  height: fit-content;
  color: #fff;
  transform: translateX(-50%) rotate(-15deg);
  cursor: pointer;
}
</style>
